import { Navigate, useParams } from 'react-router-dom';

import Community from '@pages/Community';
import Profile from '@pages/Profile';
import { profileHandleFromSlug, profilePath } from '@helpers/profile';

/**
 * `/:slug` is a community, unless the segment is an `@handle`: then it is that
 * user's public profile (`/@nickname`). React Router only matches whole
 * segments, so `/@:handle` cannot be registered as its own route — this
 * dispatcher tells the two apart by the prefix instead.
 */
export default function SlugRoute() {
    const { slug } = useParams();
    const handle = profileHandleFromSlug(slug);
    return handle ? <Profile handle={handle} /> : <Community />;
}

/** The former `/p/:handle` address, kept so links already shared keep working. */
export function LegacyProfileRedirect() {
    const { handle } = useParams();
    return <Navigate to={profilePath(handle)} replace />;
}
